(function(){
  if (!window.Glide) return;

  document.querySelectorAll('.js-glide-root').forEach(root => {
    const el = root.querySelector('.glide');
    if (!el) return;

    const bool = v => String(v) === 'true';
    const int  = (v, d=0) => { const n = parseInt(v, 10); return isNaN(n) ? d : n; };

    const opts = {
      type: root.dataset.mode || 'carousel',
      focusAt: (root.dataset.focus === 'center') ? 'center' : int(root.dataset.focus, 0),
      perView: int(root.dataset.pvD, 1),
      gap: int(root.dataset.gapD, 0),
      hoverpause: bool(root.dataset.hoverpause),
      rewind: bool(root.dataset.rewind),
      bound: bool(root.dataset.bound),
      keyboard: bool(root.dataset.keyboard),
      autoplay: bool(root.dataset.autoplay) ? int(root.dataset.autoplayMs, 5000) : false,
      peek: bool(root.dataset.peek) ? { before: int(root.dataset.peekBefore,0), after: int(root.dataset.peekAfter,0) } : 0,
      breakpoints: {
        990: { perView: int(root.dataset.pvT, 1), gap: int(root.dataset.gapT, 0) },
        749: { perView: int(root.dataset.pvM, 1), gap: int(root.dataset.gapM, 0) }
      }
    };

    new Glide(el, opts).mount();
  });
})();
